import { makeStyles } from "@material-ui/core/styles";
import { themeColors } from "../../../components/css/themeConfig";
import { useSelector } from "react-redux";

const useStyles = () => {
  const themeName = useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  return makeStyles((theme) => ({
    closeButton: {
      color: themeColors[themeName].color,
      float: "right",
    },
    paper: {
      borderRadius: 8,
      backgroundColor: themeColors[themeName].headerColor,
      minWidth: "calc(50vw - 32px)",
      minHeight: "calc(30vh - 32px)",
      maxWidth: "calc(50vw - 32px)",
      WebkitFontSmoothing: "antialiased",
      boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
      "&:focus": {
        outline: "none",
      },
    },
    header: {
      backgroundColor: themeColors[themeName].headerColor,
      color: themeColors[themeName].color,
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    },
    title: {
      fontSize: 24,
      color: "white",
      fontWeight: "bold",
    },
    content: {
      padding: theme.spacing(4),
      backgroundColor: "#f1f1f1",
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
      maxHeight: "calc(70vh - 32px)",
      overflowY: "auto",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: theme.spacing(2),
      backgroundColor: "#f1f1f1",
    },
  }));
};

export default useStyles;
